
namespace Matrix.Indexation {
    export class IndexPriceColumns {
        static columnsKey = 'Indexation.IndexPrice';
    }
}